import { header } from "./modules/header";
import { anchorScroll } from "./modules/anchorScroll";
import { inview } from "./modules/inview";

window.addEventListener("DOMContentLoaded", () => {
  header();
  anchorScroll();
  inview();
});
